import { atom } from "jotai";
import { 사망_표현_LIST } from "./constants";
import { ObituaryClientSangjuState, ObituaryClientState } from "./type";
import { v4 } from "uuid";

export const DEFAULT_OBITUARY: ObituaryClientState = {
  name: "",
  age: undefined,
  is_age_public: true,
  passed_away_on: undefined,
  die_term: 사망_표현_LIST[0],
  religion: undefined,
  religious_position: undefined,
  baptismal_name: undefined,
  binso: "",
  jangji: "",
  parlor: undefined,
  parlor_address: undefined,
  enter_parlor_at: {
    date: undefined,
    time: undefined,
  },
  ilpo: {
    date: undefined,
    time: undefined,
  },
  is_ilpo_public: true,
  enter_coffin_at: {
    date: undefined,
    time: undefined,
  },
  leave_parlor_at: {
    date: undefined,
    time: undefined,
  },
  custom_message: "",
};

export const obituaryAtom = atom(DEFAULT_OBITUARY);

const defaultObituaryError: Record<
  keyof ObituaryClientState,
  boolean | { date: boolean; time: boolean }
> = {
  name: false,
  age: false,
  is_age_public: false,
  passed_away_on: false,
  die_term: false,
  religion: false,
  religious_position: false,
  baptismal_name: false,
  binso: false,
  jangji: false,
  parlor: false,
  parlor_address: false,
  enter_parlor_at: {
    date: false,
    time: false,
  },
  ilpo: {
    date: false,
    time: false,
  },
  is_ilpo_public: false,
  enter_coffin_at: {
    date: false,
    time: false,
  },
  leave_parlor_at: {
    date: false,
    time: false,
  },
  custom_message: false,
};
export const obituaryErrorAtom = atom(defaultObituaryError);

export const DEFAULT_OBITUARY_SANGJU: ObituaryClientSangjuState = {
  clientId: v4(),
  key: "",
  name: "",
  relation: "",
  hasPhone: true,
  phone: {
    first: "010",
    second: "",
  },
};

export const DEFAULT_OBITUARY_SANGJUS: ObituaryClientSangjuState[] = Array.from(
  { length: 1 },
  () => DEFAULT_OBITUARY_SANGJU
);

export const obituarySangjusAtom = atom<ObituaryClientSangjuState[]>(
  DEFAULT_OBITUARY_SANGJUS
);

export const portraitPhotoAtom = atom<string | null>(null);
export const portraitPhotoFileAtom = atom<File | null>(null);

export const obituarySangjuFormStatusAtom = atom<{
  isInitial: boolean;
  isSubmitting: boolean;
}>({
  isInitial: true,
  isSubmitting: true,
});
